import "./index.scss";
export var ParagraphHeader = function ParagraphHeader(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    className: "paragraphHeader"
  }, children);
};